import { tv } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
import { cc } from "../../../../lib/utils.js";
const inputSizeVariants = tv({
  slots: {
    size: void 0,
    space: void 0,
    fontSize: void 0
  },
  variants: {
    size: {
      sm: { size: "h-6", space: "px-1", fontSize: "text-sm" },
      default: { size: "h-9", space: "px-2", fontSize: "text-base" },
      lg: { size: "h-10", space: "px-2", fontSize: "text-lg" }
    }
  },
  defaultVariants: {
    size: "default"
  }
}), { size: defaultSizeVariants, space: defaultSpaceVariants, fontSize: defaultFontSizeVariants } = inputSizeVariants(), { size: smSizeVariants, space: smSpaceVariants, fontSize: smFontSizeVariants } = inputSizeVariants({ size: "sm" }), { size: lgSizeVariants, space: lgSpaceVariants, fontSize: lgFontSizeVariants } = inputSizeVariants({ size: "lg" }), inputBaseVariants = tv({ base: "flex w-full min-w-0 py-1 border transition-[background-color,border-color,color,box-shadow]" }), inputBaseTextVariants = tv({ base: "outline-none selection:bg-(--primary-2) selection:text-(--pure-white)" }), inputVariants = tv({
  slots: {
    // 当input没有前后图标时，只渲染成input
    input: [
      inputBaseVariants(),
      inputBaseTextVariants(),
      `
        ${cc(
        /* 定义文字颜色 */
      )}
        text-(--gray-text-2) placeholder:text-(--gray-primary-1-alpha)
        ${cc(
        /* 定义禁用时的状态 */
      )}
        disabled:bg-(--gray-tag-1-alpha) disabled:pointer-events-none disabled:cursor-not-allowed
        ${cc(
        /* 定义focus时的颜色 */
      )}
        focus:border-(--border-3-alpha) focus:ring-(--border-1-alpha) focus:ring-[1px]
        ${cc(
        /* 定义错误时的颜色 */
      )}
        aria-invalid:border-(--red-6-alpha) aria-invalid:focus:ring-(--red-3-alpha)
      `
    ],
    // 当有图标时使用的样式，外层是span
    container: [
      inputBaseVariants(),
      `
        ${cc(
        /* 定义禁用时的状态 */
      )}
        has-[input:disabled]:bg-(--gray-tag-1-alpha) has-[input:disabled]:pointer-events-none has-[input:disabled]:cursor-not-allowed
        ${cc(
        /* 定义focus时的颜色 */
      )}
        has-[input:focus]:border-(--border-3-alpha) has-[input:focus]:ring-(--border-1-alpha) has-[input:focus]:ring-[1px]    
        ${cc(
        /* 定义错误时的颜色 */
      )}
        has-[input[aria-invalid=true]]:border-(--red-6-alpha) has-[input[aria-invalid=true]:focus]:ring-(--red-3-alpha)
      `
    ]
  },
  variants: {
    variant: {
      default: {},
      filled: {
        input: "focus:not-read-only:not-aria-invalid:bg-(--tag-3-alpha) aria-invalid:bg-(--red-3-alpha)",
        container: "has-[input:focus]:bg-(--tag-3-alpha) has-[input[aria-invalid=true]]:bg-(--red-3-alpha)"
      }
    },
    size: { sm: {}, default: {}, lg: {} },
    // 用于给其他组件使用时，取消readonly的背景色
    readonlyStyleDisabled: {
      false: {
        input: "read-only:bg-(--gray-tag-1-alpha)",
        container: "has-[input:read-only]:bg-(--gray-tag-1-alpha)"
      },
      true: {}
    }
  },
  compoundSlots: [
    { slots: ["input", "container"], variant: "default", class: "bg-(--white) border-(--gray-tag-3-alpha)" },
    { slots: ["input", "container"], variant: "filled", class: "bg-(--tag-1-alpha) border-transparent" },
    { slots: ["input", "container"], size: "sm", class: [smSizeVariants(), smSpaceVariants(), smFontSizeVariants()] },
    { slots: ["input", "container"], size: "default", class: [defaultSizeVariants(), defaultSpaceVariants(), defaultFontSizeVariants()] },
    { slots: ["input", "container"], size: "lg", class: [lgSizeVariants(), lgSpaceVariants(), lgFontSizeVariants()] }
  ],
  defaultVariants: {
    variant: "default",
    size: "default",
    readonlyStyleDisabled: !1
  }
}), inputValueVariants = tv({
  base: ["w-full bg-transparent", inputBaseTextVariants()]
}), inputPlaceholderVariants = tv({
  variants: {
    placeholder: { false: void 0, true: "text-ellipsis" }
  },
  defaultVariants: {
    placeholder: !1
  }
}), inputRoundedVariants = tv({
  variants: {
    before: { true: "rounded-s-md", false: void 0 },
    after: { true: "rounded-e-md", false: void 0 }
  }
}), inputFixWrapperSpaceVariants = tv({
  base: "flex items-center",
  variants: {
    size: { sm: "gap-1", default: "gap-2", lg: "gap-2" }
  },
  defaultVariants: {
    size: "default"
  }
}), inputAddAndFixTextVariants = tv({
  variants: {
    invalid: { false: "text-(--gray-text-2)", true: "text-(--red-9)" }
  },
  defaultVariants: {
    invalid: !1
  }
}), inputAddonWrapperVariants = tv({
  base: "content-center",
  variants: {
    variant: { default: "border-t border-b bg-(--white)", filled: void 0 },
    rounded: { before: "rounded-s-md", after: "rounded-e-md" },
    border: { before: void 0, after: void 0 },
    invalid: { false: "border-(--gray-tag-3-alpha)", true: "border-(--red-6-alpha)" },
    size: {
      sm: [smSizeVariants(), smSpaceVariants(), smFontSizeVariants()],
      default: [defaultSizeVariants(), defaultSpaceVariants(), defaultFontSizeVariants()],
      lg: [lgSizeVariants(), lgSpaceVariants(), lgFontSizeVariants()]
    }
  },
  compoundVariants: [
    // 默认变体
    { border: "before", variant: "default", class: "border-s" },
    { border: "after", variant: "default", class: "border-e" },
    // filled变体
    { invalid: !1, variant: "filled", class: "border-transparent bg-(--tag-1-alpha)" },
    { invalid: !0, variant: "filled", class: "border-t border-b bg-(--red-3-alpha)" },
    // filled变体 + border
    { invalid: !0, variant: "filled", border: "before", class: "border-s" },
    { invalid: !0, variant: "filled", border: "after", class: "border-e" }
  ],
  defaultVariants: {
    variant: "default",
    size: "default",
    invalid: !1
  }
});
export {
  inputAddAndFixTextVariants,
  inputAddonWrapperVariants,
  inputFixWrapperSpaceVariants,
  inputPlaceholderVariants,
  inputRoundedVariants,
  inputSizeVariants,
  inputValueVariants,
  inputVariants
};
//# sourceMappingURL=index.js.map
